import styled from "styled-components";
import { useEffect, useState } from "react";
import { Meta } from "src/@types/paginated";
interface MetaButtonsProps {
  pagination: Meta
  setPagination: (pag: Meta) => void;
}

export const PaginationButtons = ({ pagination, setPagination }: MetaButtonsProps) => {
  const [pagesToShow, setPagesToShow] = useState<(string | number)[]>([]);

  function getPagesToShow(pagination: Meta) {
    const { currentPage, total } = pagination ?? {} as Meta;
    const result: (string | number)[] = [];

    const startPage = Math.max(1, Math.min(currentPage - 1, total - 3));
    const endPage = Math.min(startPage + 3, total);

    if (total > 5 && currentPage > 3) {
      result.push(1)  
      result.push("...")  
    } 

    for (let i = startPage; i <= endPage; i++) {
      result.push(i);
    }

    if (result[result.length - 1] !== total) {
      if ((result[result.length - 1] as number + 1) !== total) {
        result.push("...")
      }
      result.push(total);
    }

    setPagesToShow(result);
  }

  function handleSetPage(page: number | string) {
    if (typeof page === 'number' && page > 0) {
      setPagination({
        ...pagination,
        currentPage: page,
        next: (page + 1) <= pagination?.total ? (page + 1) : null,
        prev: page !== 1 ? (page - 1) : null,
      })
    }
  }

  useEffect(() => {
    getPagesToShow(pagination)
  }, [pagination])

  return (
    <PaginationButtonsContainer>
      <button
        className={`navigate-btn previous ${pagination?.prev ? "" : "disabled"}`}
        onClick={() => handleSetPage(pagination?.currentPage - 1)}
        disabled={!pagination?.prev}
      >
        Anterior
      </button>
      {pagesToShow.map(page => (
        <span
          className={`pages ${page === pagination?.currentPage ? "selected" : ""} ${page === "..." ? "ocult" : ""}`}
          onClick={() => handleSetPage(page)}
        >
          {page}
        </span>
      ))}
      <button
        className={`navigate-btn next ${pagination?.next ? "" : "disabled"}`}
        onClick={() => handleSetPage(pagination?.currentPage + 1)}
        disabled={!pagination?.next}
      >
        Próximo
      </button>
    </PaginationButtonsContainer>
  );
};

const PaginationButtonsContainer = styled.div`
  display: flex;
  font-size: 14px;
  
  .pages {
    display: flex;
    justify-content: center;
    padding: 8px 6px;
    border: 1px solid #DCDCE3;
    border-left: none;
    border-top: none;
    min-width: 29px;
    
    &.selected {
      background-color: #F4C83E;
    }
  }
  
  .pages:not(.ocult) {
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
  }

  .navigate-btn {
    cursor: pointer;
    padding: 6px 12px;
    background-color: #2B0C1A;
    color: #FFF;

    &.previous {
     border-radius: 0 0 0 8px;
    }

    &.next {
     border-radius: 0 0 8px 0;
    }

    &:hover {
      text-decoration: underline;
    }

    &.disabled {
      color: #8D91A2;
      background-color: #D9DAE0;
      cursor: not-allowed;
      text-decoration: none;
    }
  }
`;

